export function findColorForDeviationType(deviationTypeName: string) {
  switch (deviationTypeName) {
    case "Improvement":
      return "SkaneGreen";
    case "Urgent":
      return "PrimaryRed";
    case "Vandalism":
      return "AudienceGrey2";
    default:
      return "PrimaryBlack";
  }
}
const AvvikelsetypColors = {
  Vandalism: "#B4B414",
  Urgent: "#B41414",
  Improvement: "#14B414",
  Other: "#505050",
};

export const getColorForAvvikelsetyp = (
  avvikelsetyp: string | undefined
): string => {
  if (!avvikelsetyp) {
    return AvvikelsetypColors.Other;
  }
  switch (avvikelsetyp) {
    case "Förbättringsförslag":
      return AvvikelsetypColors.Improvement;
    case "Akut":
      return AvvikelsetypColors.Urgent;
    case "Vandalisering":
      return AvvikelsetypColors.Vandalism;
    case "Övrigt":
      return AvvikelsetypColors.Other;
    default:
      return AvvikelsetypColors.Other;
  }
};
